module.exports = __webpack_public_path__ + "static/img/media5.6171a04.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/media5.png
// module id = 8p4b
// module chunks = 7